import CardColumn from "components/CardColumn";
import React from "react";
import { useTranslation } from "react-i18next";

const TasksHeading = () => {
	const { t } = useTranslation();

	return (
		<div className="list-group-heading activity-instances__heading">
			<CardColumn
				width="xl"
				className="activity-instances-card--heading__task__title">
				{t("main.activityInstances.tasks.headings.title")}
			</CardColumn>
			<CardColumn
				width="xs"
				className="activity-instances-card--heading__task__status">
				{t("main.activityInstances.tasks.headings.status")}
			</CardColumn>
			<CardColumn
				width="sm"
				className="activity-instances-card--heading__task__created">
				{t("main.activityInstances.tasks.headings.created")}
			</CardColumn>
			<CardColumn
				width="sm"
				className="activity-instances-card--heading__task__dueDate">
				{t("main.activityInstances.tasks.headings.dueDate")}
			</CardColumn>
			<CardColumn
				width="xs"
				className="activity-instances-card--heading__task__priority">
				{t("main.activityInstances.tasks.headings.priority")}
			</CardColumn>
			<CardColumn
				width="sm"
				className="activity-instances-card--heading__task__assignee">
				{t("main.activityInstances.tasks.headings.assignee")}
			</CardColumn>
		</div>
	);
};

export default TasksHeading;
